function CountMaintenance({
  plates,
  correctiveMaintenance,
  schedulePreventiveMaintenance,
  preventiveMaintenancePerformed,
  filterLabel,
}) {
  return(
   <div className="container py-1">
  <div className="d-flex justify-content-center align-items-center gap-3 flex-wrap">
    <div className="d-flex flex-column align-items-center">
      <div className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center" style={{ width: '60px', height: '60px' }}>
        <span className="fs-5 fw-bold">{plates}</span>
      </div>
      <p className="mb-0 small" style={{ fontSize: '0.75rem' }}>Placas</p>
    </div>
    <div className="d-flex flex-column align-items-center">
      <div className="rounded-circle bg-success text-white d-flex align-items-center justify-content-center" style={{ width: '60px', height: '60px' }}>
        <span className="fs-5 fw-bold">{schedulePreventiveMaintenance}</span>
      </div>
      <p className="mb-0 small" style={{ fontSize: '0.75rem' }}>Preventivos programados</p>
    </div>
      <div className="d-flex flex-column align-items-center">
      <div className="rounded-circle bg-info text-white d-flex align-items-center justify-content-center" style={{ width: '60px', height: '60px' }}>
        <span className="fs-5 fw-bold">{correctiveMaintenance}</span>
      </div>
      <p className="mb-0 small" style={{ fontSize: '0.75rem' }}>Mantenimientos correctivos</p>
    </div>
    <div className="d-flex flex-column align-items-center">
      <div className="rounded-circle bg-warning text-white d-flex align-items-center justify-content-center" style={{ width: '60px', height: '60px' }}>
        <span className="fs-5 fw-bold">{preventiveMaintenancePerformed}</span>
      </div>
      <p className="mb-0 small" style={{ fontSize: '0.75rem' }}>Preventivos ejecutados</p>
    </div>
    {filterLabel && (
      <span className="text-muted ms-2" style={{ fontSize: '0.75rem' }}>
        <strong>Periodo:</strong> {filterLabel}
      </span>
    )}
  </div>
</div>

  );
}

export default CountMaintenance;
